import {
  API_CONSTANTS,
  callAPI,
  WORKER_TASK_ENDPOINT,
} from "../../app/api/callAPI";

export const MULTIPLE_LOCATION_JOB_EMPLOYER_ID = "MULTIPLE_LOCATIONS_JOB";

export function filterOutMultiLocJobs(jobs) {
  return jobs.filter(
    (job) => job.employerId !== MULTIPLE_LOCATION_JOB_EMPLOYER_ID
  );
}

export function showQuickJobLocation(job) {
  return job.multipleLocations.length > 0
    ? "Multiple locations"
    : job.location.areaLevelOne;
}

export function isMultiLocJob(employerId) {
  return employerId === MULTIPLE_LOCATION_JOB_EMPLOYER_ID;
}

export async function checkToUpdateMultiLocJobs({ job, email }) {
  if (job.isMultipleLocations) {
    await callAPI({
      endpoint: WORKER_TASK_ENDPOINT,
      opts: {
        body: {
          task: API_CONSTANTS.worker.updateMultipleLocJobs,
          id: job.id,
          email: email,
        },
      },
    });
  }
}
